import React, {useState, useEffect} from 'react';
import sAction from 'sAction';

function CarouselWidget() {
    const slidesChangeTime = 5000;
    const [state, setState] = useState({
        active: 0,
        carouselActive: true,
        slides: [],
    });

    let activeIndex = 0;
    let interval = null;

    useEffect(() => {
        if (state.slides.length === 0) {
            getCarouselData();
        }
    }, [state.carouselActive]);

    useEffect(() => {
        if (state.carouselActive && state.slides.length > 1 && interval === null) {
            interval = setInterval(() => {
                nextSlide();
            }, slidesChangeTime);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [state.slides]);

    const getCarouselData = () => {
        const params = {};
        sAction.rest.post('getLoginCarrousel', params, function(resp) {
            if (resp.status && resp.message.data.length > 0) {
                const slides = [];
                resp.message.data.forEach((item, index) => {
                    slides.push({
                        id: index,
                        secTitle: item.subject,
                        title: item.headline,
                        text: item.description,
                        button: item.button_label,
                        btnLink: item.url,
                    });
                });

                setState({
                    ...state,
                    slides: slides,
                });
            }
        });
    };

    const changeSlide = (index) => {
        setState({
            ...state,
            active: index,
            carouselActive: false,
        });
        activeIndex = index;
    };

    const nextSlide = () => {
        const nextSlideIndex = activeIndex === state.slides.length - 1 ? 0 : activeIndex + 1;
        setState({
            ...state,
            active: nextSlideIndex,
        });
        activeIndex = nextSlideIndex;
    };

    return (
        <div className="loginCarouselWidget">
            <div className="infoCarouselInnerBox">

                {
                    state.slides.map((slide, index) => {
                        return (
                            <div className={'carouselContentBox' + (state.active === index ? ' active' : '')} key={index}>
                                <p className="contentSecHeadline">{slide.secTitle}</p>
                                <h1 className="contentHeadline">{slide.title}</h1>
                                <p>{slide.text}</p>
                                <br/>
                                {slide.button && <a href={slide.btnLink} className="button outlined squareWhite">{slide.button}</a>}
                            </div>
                        );
                    })
                }

                <div className="carouselDotNavigation">
                    {
                        state.slides.map((slide, index) => {
                            return (
                                <div className={'navDot' + (state.active === index ? ' active' : '')}
                                    key={'loginCarouselWidget' + index}
                                    onClick={() => {
                                        changeSlide(index);
                                    }}></div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default CarouselWidget;
